<template>
  <div class="price-total-notice" v-if="count > 0">
    <span class="title"
      >总计：共 <span class="price">{{ count }}</span> 笔订单</span
    >
    <span class="price-container" v-for="(item, index) in list" :key="index"
      >{{ item.title }} <span class="price">¥{{ item.price }}</span>
    </span>
  </div>
</template>
<script>
export default {
  name: "priceTotalNotice",
  props: {
    list: {
      type: Array,
      default: () => [{ title: "", price: 0 }],
    },
    count: {
      type: Number,
      default: 0,
    },
  },
};
</script>
<style scoped lang="scss">
.price-total-notice {
  display: flex;
  padding-bottom: 10px;
  .title {
    font-size: 14px;
    color: #333;
    margin-right: 10px;
    line-height: 1;
  }
  .price-container {
    font-size: 14px;
    color: #595959;
    line-height: 1;
  }
  .price {
    font-size: 14px;
    color: #f5222d;
    margin: 0px 12px 0px 0px;
    font-weight: bold;
  }
}
</style>
